/**
 * @generated SignedSource<<0568ae0aac4a3e66c830d3cab42008c1>>
 * @relayHash 4f89917ddb34cc6f55bd3f83b120247c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 54cae0decb637cef0edcfaeee9b93a4b6a124fbbaa250d2d03b8cd565eee956f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FilterRefinementTimelineQuery } from './FilterRefinementTimelineQuery.graphql';

const node: PreloadableConcreteRequest<FilterRefinementTimelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "54cae0decb637cef0edcfaeee9b93a4b6a124fbbaa250d2d03b8cd565eee956f",
    "metadata": {},
    "name": "FilterRefinementTimelineQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
